export enum ActionOptionModalError {
  READ_QRCODE_AGAIN = 1,
  GET_ESTABLISHMENT_BY_CODE,
}
